import { UnstyledLink } from '@aboutyou/legacy-shared/src/ui/Navigation/ClientSideLink/UnstyledLink'
import styled, { css } from 'styled-components'
import { FittedImage } from 'uiComponents/atoms/FittedImage'
import Icon from 'uiComponents/atoms/Icon/Icon'
import {
  complementaryColor,
  primaryColor,
  shade30,
  shade40,
} from 'uiComponents/constants/colors'
import {
  mediaLargeScreens,
  mediaMaxS,
} from 'uiComponents/constants/customMedia'
import {
  fsM,
  fsXS,
  fsXXL,
  fwBold,
  fwHeavy,
} from 'uiComponents/constants/typography'

export const TeaserBackground = styled(FittedImage)``
export const AbsoluteTeaserBackground = styled(FittedImage)`
  position: absolute;
  top: 0;
  object-position: center;
`

export const PageHolder = styled.section`
  padding: 0 20px;
  max-width: 1920px;
  margin: 0 auto;

  @media only screen and (max-width: 1023px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  @media only screen and (min-width: 1024px) {
    padding-left: 30px;
    padding-right: 30px;
  }

  @media only screen and (min-width: 1280px) {
    padding-left: 60px;
    padding-right: 60px;
  }
`

export const ContentBannerSections = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const ContentBannerSection = styled.article<{
  isWide?: boolean
  noImage?: boolean
}>`
  position: relative;
  flex: 1 1 auto;
  align-self: stretch;

  &:not(:last-child) {
    margin-right: 1px;
  }

  a {
    display: block;
  }

  ${({ isWide }) =>
    isWide
      ? css`
          flex-basis: 63.33%;
          aspect-ratio: 626 / 357;
        `
      : css`
          flex-basis: 36.59%;
          aspect-ratio: 361 / 357;
        `};

  ${({ noImage }) =>
    noImage &&
    css`
      min-height: 350px;
      @media ${mediaLargeScreens} {
        min-height: 500px;
      }
    `};
`

const absPositionCss = css`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`

export const ContentSectionOverlay = styled.div<{
  clickable?: boolean
  fallbackColor?: string | null
  wide?: boolean
}>`
  ${absPositionCss}

  background-color: ${({ fallbackColor }) => fallbackColor ?? shade30};
  color: ${complementaryColor};
  transition: 0.3s background-color;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 0 0 ${({ clickable }) => (clickable ? '0 0' : '100px 60px')};
  &:hover {
    ${({ fallbackColor }) =>
      !fallbackColor &&
      css`
        background-color: ${shade40};
      `};
    > ul {
      max-height: 50%;
      padding-bottom: 15px;
    }
  }

  @media ${mediaMaxS} {
    padding-bottom: 0;
    padding-left: 15px;
    align-items: center;
  }
`

export const ContentClickableSection = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 0 0 150px 60px;

  @media ${mediaMaxS} {
    padding: 0 0 0 15px;
    align-items: center;
  }
`

export const ContentSectionCtaHolder = styled.div`
  flex: 1 1 auto;
  align-items: flex-start;
  justify-content: center;
  display: flex;
  flex-direction: column;
  text-align: left;
  max-width: 560px;
`

export const ContentSectionButtonsHolder = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 32px;
  text-align: center;
`

export const ContentSectionButton = styled(UnstyledLink)`
  display: inline-block;
  background-color: ${complementaryColor};
  padding: 15px 30px;
  box-sizing: border-box;
  font-size: ${fsXS}px;
  ${fwBold};
  border-radius: 2px;
  min-width: 180px;
  color: ${primaryColor} !important;
  cursor: pointer;
  &:not(:last-child) {
    margin-right: 8px;
  }
`

export const ContentSectionHeaderWide = styled.h2`
  font-size: ${fsXXL}px;
  ${fwHeavy};
  line-height: 1.1;
  letter-spacing: 0.4px;
`

export const ContentSectionHeader = styled.h2`
  font-size: ${fsXXL}px;
  ${fwHeavy};
  line-height: 1.1;
  letter-spacing: 0.4px;
  max-width: 350px;
`

export const ContentSectionSubHeaderWide = styled.h3`
  font-size: ${fsM}px;
  ${fwBold};
  line-height: 1.4;
  margin-top: 16px;
`

export const ContentSectionSubHeader = styled.h3`
  font-size: ${fsM}px;
  ${fwBold};
  line-height: 1.4;
  margin-top: 23px;
  max-width: 350px;
  text-decoration: underline;
`

export const TopBrandsContentSection = styled.section`
  margin-top: 1px;
`

export const StyledInfoIcon = styled(Icon)`
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  margin-left: 12px;
  opacity: 0.5;
  filter: invert(1);
  cursor: pointer;
`
